// ─── Constantes calibradas con datos reales de HeyGen (Marina, es-MX, speed:1) ──
// Basado en 5 videos de prueba (1920×1080). Ajustar a medida que haya más datos.

const SECONDS_PER_WORD = 0.52;          // ~115 palabras/minuto
const SCENE_OVERHEAD_SECONDS = 1.5;     // transición / arranque por escena
const KB_PER_SECOND_1080P = 450;        // bitrate promedio 1920×1080

export const getWordCount = (text: string): number => {
  const trimmed = text.trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).length;
};

export const getCharCount = (text: string): number => text.length;

/** Duración estimada de una escena en segundos (speech + overhead). */
export const estimateDuration = (text: string): number => {
  const words = getWordCount(text);
  if (words === 0) return 0;
  return Math.ceil(words * SECONDS_PER_WORD + SCENE_OVERHEAD_SECONDS);
};

/** Duración total de múltiples escenas. */
export const estimateTotalDuration = (scripts: string[]): number =>
  scripts.reduce((acc, s) => acc + estimateDuration(s), 0);

/** Tamaño estimado en MB para 1080p. */
export const estimateSizeMB = (durationSeconds: number, resolutionCount: number): number => {
  if (durationSeconds === 0) return 0;
  const kb = durationSeconds * KB_PER_SECOND_1080P * resolutionCount;
  return Math.round((kb / 1024) * 10) / 10; // redondeo a 1 decimal
};

export const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
};

export const formatDurationMinutes = (seconds: number): string => {
  if (seconds === 0) return '—';
  const mins = seconds / 60;
  return mins < 1 ? `${seconds}s` : `${mins.toFixed(1)} min`;
};
